import React, { useEffect } from "react";
import * as S from "./styles";

interface ITransfer {
  codeSend: string;
  setCodeSend: (e: string) => void;
  valueTransfer: string;
  setValueTransfer: (e: string) => void;
  setShowModal: () => void;
  handleButton: boolean;
  setHandleButton: (e: boolean) => void;
  codeUser: number;
  sald: number;
}

const Transfer: React.FC<ITransfer> = ({
  valueTransfer,
  setValueTransfer,
  setShowModal,
  setCodeSend,
  codeSend,
  handleButton,
  setHandleButton,
  codeUser,
  sald,
}) => {
  useEffect(() => {
    if (
      codeSend.length === 4 &&
      valueTransfer &&
      codeUser !== parseInt(codeSend, 10) &&
      sald >= parseInt(valueTransfer, 10)
    ) {
      if (parseInt(valueTransfer) > 0) {
        setHandleButton(false);
        return;
      }
      setHandleButton(true);
      return;
    }
    setHandleButton(true);
    return;
  }, [codeSend, valueTransfer, setHandleButton, sald, codeUser]);

  return (
    <S.TransferCard>
      <S.InputGroup>
        <S.Label>Código do Destinatário</S.Label>
        <S.Input
          placeholder="Ex: 7091"
          type="number"
          onChange={(e) => setCodeSend(e.target.value)}
          value={codeSend}
        />
      </S.InputGroup>

      <S.InputGroup>
        <S.Label>Valor da Transferência</S.Label>
        <S.Input
          placeholder="Ex: 100"
          type="number"
          onChange={(e) => setValueTransfer(e.target.value)}
          value={valueTransfer}
        />
      </S.InputGroup>

      <S.ButtonMui disabled={handleButton} onClick={() => setShowModal()}>
        Enviar Moedas <S.SendIconMui />
      </S.ButtonMui>
    </S.TransferCard>
  );
};

export default Transfer;
